// Modal de "Marcar como Pagado" para Payouts
document.addEventListener('turbo:load', function() {
  console.log('Payouts Modal Script Loaded');
  
  // Usar el evento show.bs.modal de Bootstrap para capturar datos cuando el modal se abre
  const markAsPaidModal = document.getElementById('markAsPaidModal');
  
  if (markAsPaidModal) {
    markAsPaidModal.addEventListener('show.bs.modal', function(event) {
      // Botón que disparó el modal
      const button = event.relatedTarget;
      
      if (button) {
        // Extraer datos del botón
        const payoutId = button.getAttribute('data-payout-id');
        const amountAttr = button.getAttribute('data-amount');
        
        console.log('Modal opening - payout_id:', payoutId, 'amount:', amountAttr);
        
        // Actualizar campo oculto de payout_id
        const payoutIdField = document.getElementById('modal-payout-id');
        if (payoutIdField) {
          payoutIdField.value = payoutId || '';
          console.log('Set payout_id field to:', payoutIdField.value);
        } else {
          console.error('Campo modal-payout-id no encontrado');
        }
        
        // Procesar y asignar el monto
        const amountValue = amountAttr ? Number(amountAttr) : 0;
        const finalAmount = isNaN(amountValue) ? 0 : amountValue;
        
        // Actualizar campo de monto
        const amountInput = document.getElementById('modal-amount-input');
        if (amountInput) {
          amountInput.value = finalAmount.toFixed(2);
          console.log('Set amount field to:', amountInput.value);
        } else {
          console.error('Campo modal-amount-input no encontrado');
        }
      } else {
        console.error('No se pudo obtener el botón que disparó el modal');
      }
    });
    
    console.log('Modal event listener attached to #markAsPaidModal');
  } else {
    console.error('Modal #markAsPaidModal no encontrado en el DOM');
  }

  // ============================================
  // Bulk Payment Functionality
  // ============================================
  
  const selectAllCheckbox = document.getElementById('selectAll');
  const bulkPayBtn = document.getElementById('bulk-pay-btn');
  const selectedCountSpan = document.getElementById('selected-count');
  
  console.log('Bulk Payment Elements:', {
    selectAll: !!selectAllCheckbox,
    button: !!bulkPayBtn,
    counter: !!selectedCountSpan
  });
  
  function updateBulkPayButton() {
    const checkedBoxes = document.querySelectorAll('.payout-checkbox:checked');
    const count = checkedBoxes.length;
    
    if (selectedCountSpan) {
      selectedCountSpan.textContent = count;
    }
    
    if (bulkPayBtn) {
      bulkPayBtn.disabled = (count === 0);
    }
  }
  
  if (selectAllCheckbox) {
    // Select/deselect all checkboxes
    selectAllCheckbox.addEventListener('change', function() {
      const checkboxes = document.querySelectorAll('.payout-checkbox');
      checkboxes.forEach(checkbox => {
        checkbox.checked = selectAllCheckbox.checked;
      });
      updateBulkPayButton();
    });
  }

  
  // Update button when individual checkboxes change
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('payout-checkbox')) {
      updateBulkPayButton();
      
      // Update "select all" checkbox state
      if (selectAllCheckbox) {
        const checkboxes = document.querySelectorAll('.payout-checkbox');
        const checkedBoxes = document.querySelectorAll('.payout-checkbox:checked');
        selectAllCheckbox.checked = checkboxes.length > 0 && checkboxes.length === checkedBoxes.length;
      }
    }
  });
  
  // Initial state
  updateBulkPayButton();
  console.log('Payouts Modal Script Ready');
});